import { render } from "./NewsDetails.vue?vue&type=template&id=4cb3916d"
import script from "./NewsDetails.vue?vue&type=script&lang=js"
export * from "./NewsDetails.vue?vue&type=script&lang=js"
script.render = render

export default script